import video from './06.08.2023_08.35.41_REC.mp4'

export const UploadHelp = () => {
    return (
        <>
            <h3>Указания за качване на файл с данни</h3>
            <p>Файла трябва да бъде в csv формат. В случай, че имате таблица в Excel с първоначални данни, може лесно да
                бъде записана в csv файл.</p>
            <p>Файла задължително трябва да има следните колони:</p>
            <div style={{marginTop: "1rem"}}>
                <table className="table">
                    <thead>
                    <tr>
                        <th>bullstat</th>
                        <th>company_name</th>
                        <th>declared_land</th>
                        <th>unsuitable_land</th>
                        <th>suitable_land</th>
                        <th>year</th>
                        <th>settlement_ekatte</th>
                    </tr>
                    </thead>
                </table>
            </div>
            <p style={{color: "var(--app-danger-fg)"}}>ВАЖНО: Колоните задължително трябва да бъдат в тази последователност и
                наименованията им да бъдат точно така изписани на латиница!</p>
            <p>Преди качване, моля отворете файла с Notepad или подобна програма и се уверете, че разделителят между
                данните е запетая, а не нещо друго - например точка и запетая. Ако разделителят не е запетая може лесно
                да го замените навсякъде с Ctrl+H.</p>
            <p>Кратко видео на описаните по - горе стъпки:</p>
            <div>
                <video controls width="75%">
                    <source src={video} type="video/mp4"/>
                </video>

            </div>
        </>
    )
}